import React, { useEffect, useState } from 'react'
import { User } from '../../types/User'
import { Paper, Checkbox } from '@material-ui/core'
import VirtualizedTable from '../atoms/VirtualizedTable'

const UserInfoTable: React.FC<{
  users: User[]
  checkUsers?: User[]
  height?: number
  onDelete: boolean
  displayKatudouStatus: boolean
  displayKaiinEmail: boolean
  handleCheckUsers: (users: User[]) => void
}> = ({
  users,
  checkUsers,
  height = 600,
  onDelete,
  displayKatudouStatus,
  displayKaiinEmail,
  handleCheckUsers
}) => {
  const [selectUsers, setSelectUsers] = useState<User[]>([])

  useEffect(() => {
    setSelectUsers(checkUsers)
    handleCheckUsers(checkUsers)
  }, [])

  const handleCheck = async (userId: number) => {
    const _selectUsers = [...selectUsers]
    if (_selectUsers.some(user => user.id === userId)) {
      setSelectUsers(_selectUsers.filter(user => user.id !== userId))
      handleCheckUsers(_selectUsers.filter(user => user.id !== userId))
    } else {
      _selectUsers.push(users.filter(user => user.id === userId)[0])
      setSelectUsers(_selectUsers)
      handleCheckUsers(_selectUsers)
    }
  }

  const formatUsers = (
    user: User,
    selectUsers: User[],
    onDelete: boolean,
    displayKatudouStatus: boolean,
    displayKaiinEmail: boolean
  ) => {
    console.log(user)
    const nameKana =
      user.name_last_kana && user.name_first_kana
        ? ` (${user.name_last_kana} ${user.name_first_kana})`
        : ''
    const forms = {
      kaiin_no: user.kaiin_no,
      name: `${user.name_last} ${user.name_first} ${nameKana}`,
      affiliation: `${user.affiliation} ${user.position}`
    }
    let format = {}
    format = onDelete
      ? {
          delete: (
            <Checkbox
              checked={selectUsers.some(s => s.id === user.id)}
              onChange={() => handleCheck(user.id)}
              value={user.id}
              style={{ marginTop: -13 }}
            />
          ),
          ...forms
        }
      : { ...forms }
    format = displayKatudouStatus
      ? { ...format, katudou_status: user.katudou_status === '1' ? '在会' : '退会' }
      : { ...format }
    format = displayKaiinEmail ? { ...format, kaiin_email: user.kaiin_email } : { ...format }
    return format
  }

  const formatColumns = (
    onDelete: boolean,
    displayKatudouStatus: boolean,
    displayKaiinEmail: boolean
  ) => {
    let columns = []
    if (onDelete)
      columns.push({
        width: 200,
        label: '送信対象',
        dataKey: 'delete',
        align: 'center'
      })

    columns.push(
      {
        width: 300,
        label: '会員番号',
        dataKey: 'kaiin_no',
        align: 'left'
      },
      {
        width: 600,
        label: '氏名',
        dataKey: 'name',
        align: 'left'
      },
      {
        width: 600,
        label: '所属',
        dataKey: 'affiliation',
        align: 'left'
      }
    )

    if (displayKatudouStatus)
      columns.push({
        width: 200,
        label: '活動ステータス',
        dataKey: 'katudou_status',
        align: 'center'
      })
    if (displayKaiinEmail)
      columns.push({
        width: 600,
        label: 'メールアドレス',
        dataKey: 'kaiin_email',
        align: 'left'
      })
    return columns
  }

  return (
    <React.Fragment>
      <Paper style={{ height: height, width: '100%' }}>
        <VirtualizedTable
          headerHeight={50}
          rowHeight={50}
          rowCount={users.length}
          rowGetter={({ index }) => {
            return formatUsers(
              users[index],
              selectUsers,
              onDelete,
              displayKatudouStatus,
              displayKaiinEmail
            )
          }}
          columns={formatColumns(onDelete, displayKatudouStatus, displayKaiinEmail)}
        />
      </Paper>
    </React.Fragment>
  )
}

export default UserInfoTable

// ---

// type Sample = [string, number, number, number, number]

// const sample: Sample[] = [
//   ['Frozen yoghurt', 159, 6.0, 24, 4.0],
//   ['Ice cream sandwich', 237, 9.0, 37, 4.3],
//   ['Eclair', 262, 16.0, 24, 6.0],
//   ['Cupcake', 305, 3.7, 67, 4.3],
//   ['Gingerbread', 356, 16.0, 49, 3.9]
// ]

// function createData(
//   id: number,
//   dessert: string,
//   calories: number,
//   fat: number,
//   carbs: number,
//   protein: number
// ): Data {
//   return { id, dessert, calories, fat, carbs, protein }
// }

// const rows: Data[] = []

// for (let i = 0; i < 200; i += 1) {
//   const randomSelection = sample[Math.floor(Math.random() * sample.length)]
//   rows.push(createData(i, ...randomSelection))
// }

// export default function ReactVirtualizedTable() {
//   return (
//     <Paper style={{ height: 400, width: '100%' }}>
//       <VirtualizedTable
//         rowCount={rows.length}
//         rowGetter={({ index }) => rows[index]}
//         columns={[
//           {
//             width: 200,
//             label: 'Dessert',
//             dataKey: 'dessert'
//           },
//           {
//             width: 120,
//             label: 'Calories\u00A0(g)',
//             dataKey: 'calories',
//             numeric: true
//           },
//           {
//             width: 120,
//             label: 'Fat\u00A0(g)',
//             dataKey: 'fat',
//             numeric: true
//           },
//           {
//             width: 120,
//             label: 'Carbs\u00A0(g)',
//             dataKey: 'carbs',
//             numeric: true
//           },
//           {
//             width: 120,
//             label: 'Protein\u00A0(g)',
//             dataKey: 'protein',
//             numeric: true
//           }
//         ]}
//       />
//     </Paper>
//   )
// }
